import { openBlock as e, createElementBlock as l, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ t("path", {
  fill: "#6DA544",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), c = /* @__PURE__ */ t("path", {
  fill: "#FFDA44",
  d: "M20 7.826 36.522 20 20 32.174 3.478 20 20 7.826Z"
}, null, -1), s = /* @__PURE__ */ t("path", {
  fill: "#F0F0F0",
  d: "M20 26.956a6.956 6.956 0 1 0 0-13.912 6.956 6.956 0 0 0 0 13.912Z"
}, null, -1), i = /* @__PURE__ */ t("path", {
  fill: "#0052B4",
  d: "M16.522 19.565c-1.21 0-2.377.184-3.476.526a6.955 6.955 0 0 0 12.651 3.9 11.723 11.723 0 0 0-9.175-4.426Zm10.306 1.768a6.956 6.956 0 0 0-13.22-4.078 14.35 14.35 0 0 1 2.914-.298c4.04 0 7.696 1.679 10.306 4.376Z"
}, null, -1), d = [
  n,
  c,
  s,
  i
];
function _(a, r) {
  return e(), l("svg", o, [...d]);
}
const f = { render: _ };
export {
  f as default,
  _ as render
};
